
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[eventId]/reservation",
      function () {
        return require("private-next-pages/events/[eventId]/reservation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[eventId]/reservation"])
      });
    }
  